<app-header *ngIf="loginType == 1" (onShowMenu)="isShowMenu = $event" class="doNotPrint"></app-header>
<app-sidebar *ngIf="loginType == 1" [showMenu]="isShowMenu" class="doNotPrint"></app-sidebar>
<div [class.main-content]="loginType == 1">
    <router-outlet></router-outlet>
</div>
<!-- <app-footer></app-footer> -->